module.exports = __webpack_public_path__ + "static/media/carousel11.8b27ddfc.jpeg";